import React from 'react';
import Skeleton from '../Skeleton/Skeleton';
import type { MuiPlaceholderProps } from '../../../types/components.props';

const MuiPlaceholder: React.FC<MuiPlaceholderProps> = ({element, isMuiFontLoaded, width, height, backgroundColor}) => {
    if (isMuiFontLoaded) {
      return element
    }

    return (
      <Skeleton 
        width={width}
        height={height}
        backgroundColor={backgroundColor}
      />
    )
  }


export default MuiPlaceholder;
